<template>
  <div class="contact">
    <template v-for="(item, i) in data">
      <EventModule :itemInfo="item" :key="`${item.type}-${i}`"></EventModule>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import VueTypes from 'vue-types'
import EventModule from './EventModule'

export default {
  name: 'contact',
  components: {
    EventModule
  },
  props: {
    data: VueTypes.array
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'isMobile'
    ])
  }
}
</script>
<style lang="scss">
@media screen and (max-width: 768px) {
  .contact blockquote {
    margin-left: 0;
  }
}
</style>
